<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Selecione o motivo do atestado
      <v-chip v-if="atestadoEnviar.motivo > 0 && step > stepConfig" small>{{
        getMotivoSelecionado().descricao
      }}</v-chip>
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <v-radio-group v-model="atestadoEnviar.motivo">
            <v-radio
              v-for="(motivo, i) in getMotivosAtestado()"
              :key="i"
              :value="motivo.codigo"
              class="pb-2"
            >
              <template v-slot:label>
                <div>
                  {{ motivo.descricao }}
                  <modal-ajuda-sit-atestado :ajuda="motivo" v-if="motivo.ajuda != ''" />
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <botoes-stepper />
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BotoesStepper from "./BotoesStepper.vue";
import ModalAjudaSitAtestado from "./ModalAjudaSitAtestado.vue";
export default {
  watch: {
    [`atestadoEnviar.tipo`]: function () {
      this.atestadoEnviar.motivo = this.getMotivosAtestado()[0].codigo;
    },
  },
  components: { BotoesStepper, ModalAjudaSitAtestado },
  computed: mapState("atestado", [
    "atestadoEnviar",
    "configs",
    "step",
    "atestSelec",
  ]),
  data: () => ({
    stepConfig: 20,
  }),
  methods: {
    ...mapGetters("atestado", ["getMotivoSelecionado"]),
    getMotivosAtestado() {
      if (this.atestadoEnviar.tipo > 0) {
        var motivos = this.configs.find(
          (config) => config.codigo == this.atestadoEnviar.tipo
        ).situacoes;

        if (this.atestSelec)
          return motivos.filter(
            (mot) => mot.codigo == this.atestSelec.codconfigsituacao
          );

        return motivos;
      }

      return [];
    },
  },
};
</script>

<style>
</style>